import { onlineManager } from '@tanstack/react-query';
import basicRepository, { handlerApiError } from '../../../lib/basicRepository';
import { restApi } from '../../../services/api';
import { orderConditionRepositoryFromModulesOfflineAdapters } from '../../offline/offlineRequestAdapters/orderCondition.repository.offlineAdapters';
import { OrderConditionSubmitData } from './orderCondition.types';

export const onlineOrderConditionRepository = (orderId: string, id?: string) => {
  const repository = basicRepository({
    path: `orders/${orderId}/order-conditions`,
    id,
    restApi,
  });
  const updateAll = async (data: Partial<OrderConditionSubmitData>) =>
    handlerApiError<void>(
      await restApi.patch(`orders/${orderId}/order-conditions/update-all`, data),
    );
  return {
    ...repository,
    updateAll,
  };
};

export const orderConditionRepository = (orderId: string, id?: string) =>
  onlineManager.isOnline()
    ? onlineOrderConditionRepository(orderId, id)
    : orderConditionRepositoryFromModulesOfflineAdapters(orderId);
